import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Trophy, PartyPopper, Award } from 'lucide-react';
import { Database } from '@/database.types';

const TestAlreadyTaken = ({ currentTest }: { currentTest: Database['public']['Tables']['profile_tests']['Row'] }) => {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 p-4 bg-gray-900/30 backdrop-blur-sm">
      <div className="relative bg-white rounded-2xl w-full max-w-md p-6 md:p-8 shadow-xl">
        <div className="text-center">
          {/* Fun animated icon */}
          <div className="relative mx-auto mb-8">
            {/* Background glow effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-amber-400 to-orange-500 rounded-full blur-xl opacity-20 animate-pulse"></div>
            
            {/* Rotating rings */}
            <div className="absolute inset-0 border-4 border-dashed border-amber-300 rounded-full animate-spin-slow opacity-70"></div>
            
            {/* Icon container */}
            <div className="relative bg-gradient-to-br from-amber-400 to-orange-500 w-24 h-24 mx-auto rounded-full flex items-center justify-center shadow-lg">
              <Trophy className="h-12 w-12 text-white" />
              
              {/* Little confetti burst elements */}
              <span className="absolute -top-2 -right-1 h-3 w-3 bg-pink-400 rounded-full animate-ping-slow"></span>
              <span className="absolute -bottom-1 -left-3 h-2 w-2 bg-purple-400 rounded-full animate-ping-slow delay-300"></span>
              <span className="absolute -top-3 -left-2 h-2 w-2 bg-blue-400 rounded-full animate-ping-slow delay-700"></span>
            </div>
          </div>
          
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Test Already Completed!</h2>
          <p className="mb-6 text-gray-600">
            You've already taken this test. Your results and analytics are available in your dashboard.
          </p>
          
          {/* Stats summary preview */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6 border border-gray-100">
            <div className="grid grid-cols-1 gap-2 text-center">
              <div>
                <p className="text-xs text-gray-500">Score</p>
                <p className="font-bold text-amber-600">{currentTest.score}</p>
              </div>
              {/* <div>
                <p className="text-xs text-gray-500">Completion</p>
                <p className="font-bold text-green-600">100%</p>
              </div>
              <div>
                <p className="text-xs text-gray-500">Status</p>
                <p className="font-bold text-purple-600">Completed</p>
              </div> */}
            </div>
          </div>
          
          <div className="flex flex-col space-y-3">
            <button 
              className="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white font-medium rounded-lg px-6 py-3 transition-all duration-300 hover:scale-105 focus:outline-none shadow-md"
              onClick={() => navigate('/dashboard')}
            >
              Return to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestAlreadyTaken;
